import { HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../constants/api'
import { EMPTY_LIST } from '../../../constants/common'
import {
  RENTAL_PORTAL_MOCK_LATENCY,
  RENTAL_PORTAL_MOCK_STATE,
} from '../../../constants/rentalPortalMockState'
import { VIEWINGS_SNAPSHOT } from '../../../utils/rentalPortalMockData'
import { hasRentalPortalMockState } from '../../../utils/rentalPortalMockState'

const MOCK_LISTING_VIEWINGS_READ_LATENCY = 300

const MOCK_LISTING_VIEWINGS_READ_ERROR = {
  response: { status: HTTP_STATUS_INTERNAL_SERVER_ERROR },
}

function toMockListingViewingsById(viewings) {
  return [...viewings]
    .sort((first, second) => first.start.localeCompare(second.start))
    .reduce((acc, viewing) => {
      const served = acc.get(viewing.listing_id) ?? EMPTY_LIST

      return acc.set(viewing.listing_id, [...served, viewing])
    }, new Map())
}

const MOCK_LISTING_VIEWINGS_BY_ID = toMockListingViewingsById(VIEWINGS_SNAPSHOT)

function withMockLatency() {
  const delay = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.loading)
    ? RENTAL_PORTAL_MOCK_LATENCY
    : MOCK_LISTING_VIEWINGS_READ_LATENCY

  return new Promise(resolve => {
    setTimeout(resolve, delay)
  })
}

export function getMockListingViewings({
  listing_id: listingId,
  page,
  page_size: pageSize,
}) {
  return withMockLatency().then(() => {
    if (hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.error)) {
      return Promise.reject(MOCK_LISTING_VIEWINGS_READ_ERROR)
    }

    const viewings = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.empty)
      ? EMPTY_LIST
      : (MOCK_LISTING_VIEWINGS_BY_ID.get(listingId) ?? EMPTY_LIST)

    const pageCount = Math.ceil(viewings.length / pageSize)
    const currentPage = Math.min(page, Math.max(pageCount, 1))
    const firstIndex = (currentPage - 1) * pageSize

    return {
      data: {
        pagination: {
          page: currentPage,
          page_count: pageCount,
          total: viewings.length,
        },
        results: {
          objects: viewings.slice(firstIndex, firstIndex + pageSize),
        },
      },
    }
  })
}

export function getMockListingViewingsCount(listingId) {
  return (MOCK_LISTING_VIEWINGS_BY_ID.get(listingId) ?? EMPTY_LIST).length
}
